// // ReportsBase.js - Tab-based Reports System with 9 Tabs
// // Each tab contains the dual-table functionality with dynamic columns
// // Similar structure to MNRBase.js but specifically for Reports

// import React from 'react';
// import { Tab, Tabs, Box } from '@mui/material';
// import { useDispatch, useSelector } from 'react-redux';
// import { reportsTabIndex } from '../../Redux/TabIndexSlice';
// import { isMNR } from '../../Redux/MNR/MNRCommonSlice';
// /**
//  * ReportsBase Component - Tab System for Reports
//  * 
//  * This component provides a 9-tab system where each tab contains:
//  * - Search form with validation
//  * - Main table with dynamic columns and row selection
//  * - Second table with related details and dynamic columns
//  * 
//  * Each tab operates independently with its own state management
//  */
// function ReportsBase() {
//     const dispatch = useDispatch();
//     let tab = useSelector(state => state.tab.reportsTab || 0);
//     const mnr = useSelector(state => state.role.mnr);

//     // If current tab is MMT-4 (index 3), redirect to MMT-1 (index 0)
//     if (tab === 3) {
//         tab = 0;
//         dispatch(reportsTabIndex(0));
//     }

//     const handleReportsTabIndexChange = (e, value) => {
//         // Skip hidden tabs
//         const config = tabConfigs[value];
//         if (config && config.hidden) {
//             // Find next non-hidden tab
//             const nextVisibleIndex = tabConfigs.findIndex((tc, index) => index > value && !tc.hidden);
//             if (nextVisibleIndex !== -1) {
//                 dispatch(reportsTabIndex(nextVisibleIndex));
//             }
//             return;
//         }

//         dispatch(reportsTabIndex(value));
//         dispatch(isMNR(true));
//     };

//     const renderContent = () => {
//         // Use original tab index to get the correct config
//         const config = tabConfigs[tab];
//         if (!config || config.hidden) return null;

//         return (
//             <ReportsTab
//                 tabIndex={tab}
//                 tabName={config.name}
//                 mainTableColumns={config.mainColumns}
//                 secondTableColumns={config.secondColumns}
//             />
//         );
//     };

//     const tabStyle = {
//         fontSize: 'var(--font-size-header)',
//         fontFamily: 'var(--font-family-base)',
//         minWidth: '120px',
//         textTransform: 'none'
//     };

//     const tabSxStyle = {
//         color: 'inherit',
//         '&.Mui-selected': {
//             color: 'var(--secondary-color)',
//         },
//     };

//         // Tab configuration with single Carrier column for main table
//     const tabConfigs = [
//         { name: 'MMT-1', mainColumns: 1, secondColumns: 7 },
//         { name: 'MMT-2', mainColumns: 1, secondColumns: 8 },
//         { name: 'MMT-3', mainColumns: 1, secondColumns: 8 },
//         { name: 'MMT-4', mainColumns: 1, secondColumns: 9, hidden: true }, // Hidden for now
//         // COCA/COCAY tabs hidden per requirement
//         { name: 'COCAY/Y1', mainColumns: 1, secondColumns: 7, hidden: true },
//         { name: 'COCAY/Y2', mainColumns: 1, secondColumns: 8, hidden: true },
//         { name: 'MMT-7', mainColumns: 1, secondColumns: 9 },
//         { name: 'COCAY/Y3', mainColumns: 1, secondColumns: 8, hidden: true },
//         { name: 'COCAY/Y4', mainColumns: 1, secondColumns: 7, hidden: true },
//         { name: 'COCA Other', mainColumns: 1, secondColumns: 6, hidden: true }
//     ];

//     // Filter out hidden tabs
//     const visibleTabConfigs = tabConfigs.filter(config => !config.hidden);

//     return (
//         <>
//             <Box display="flex" alignItems="flex-start" sx={{ paddingLeft: '0px', background: 'rgb(251, 249, 244)' }}>
//                 <Tabs
//                     value={tab}
//                     onChange={handleReportsTabIndexChange}
//                     variant="scrollable"
//                     scrollButtons="auto"
//                     style={{ paddingLeft: '8px' }}
//                     TabIndicatorProps={{
//                         sx: {
//                             backgroundColor: 'var(--secondary-color)',
//                         },
//                     }}
//                 >
//                     {visibleTabConfigs.map((config, visibleIndex) => {
//                         // Find the original index in tabConfigs for this visible tab
//                         const originalIndex = tabConfigs.findIndex(tc => tc.name === config.name);
//                         return (
//                             <Tab
//                                 key={originalIndex}
//                                 label={config.name}
//                                 style={tabStyle}
//                                 sx={tabSxStyle}
//                                 value={originalIndex}
//                             />
//                         );
//                     })}
//                 </Tabs>
//             </Box>

//             <Box style={{ padding: mnr ? '24px' : '0 0 0 0' }}>
//                 {renderContent()}
//             </Box>
//         </>
//     );
// }

// export default ReportsBase;

import { Tab, Tabs, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { reportsTabIndex } from '../../Redux/TabIndexSlice';
import { isMMT } from '../../Redux/MMTReports/MMTCommonSlice';
import MMT1 from '../MMTReports/MMT1';
import MMT2 from '../MMTReports/MMT2';
import MMT3 from '../MMTReports/MMT3';
import { clearData as mmt3ClearData } from '../../Redux/MMTReports/MMT3Slice';
import { clearCarrierData } from '../../Redux/Reports/ReportsCarrierSlice';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

function ReportsBase() {
    const dispatch = useDispatch();
    const tab = useSelector(state => state.tab.reportsTab || 0);
    const reports = useSelector(state => state.role.reports);
    const error = useSelector(state => state.token.error);

    useEffect(() => {
        if (error) {
            toast.error('Token API Error');
        }
    }, [dispatch, error])

    useEffect(() => {
        dispatch(isMMT(true));
        dispatch(mmt3ClearData());
        dispatch(reportsTabIndex(0));
    }, [dispatch])

    const handleReportsTabIndexChange = (e, value) => {
        // Clear carriers (list + selection) whenever user switches tabs
        dispatch(clearCarrierData());
        dispatch(reportsTabIndex(value));
    }

    const renderContent = () => {
        switch (tab) {
            case 0:
                return <MMT1 />
            case 1:
                return <MMT2 />;
            case 2:
                return <MMT3 />;
            default:
                break;
        }
    }

    return (
        <>
            <Box display="flex" alignItems="flex-start" sx={{ paddingLeft: '0px', background: 'rgb(251, 249, 244)' }}>
                <Tabs
                    value={tab}
                    onChange={handleReportsTabIndexChange}
                    variant="scrollable"
                    style={{ paddingLeft: '8px' }}
                    TabIndicatorProps={{
                        sx: {
                            backgroundColor: 'var(--secondary-color)',
                        },
                    }}
                >
                    <Tab label="MMT1"
                        style={{
                            fontSize: 'var(--font-size-header)',
                            fontFamily: 'var(--font-family-base)',
                        }}
                        sx={{
                            color: 'inherit',
                            '&.Mui-selected': {
                                color: 'var(--secondary-color)',
                            },
                        }} />
                    <Tab label="MMT2" style={{
                        fontSize: 'var(--font-size-header)',
                        fontFamily: 'var(--font-family-base)',
                    }}
                        sx={{
                            color: 'inherit',
                            '&.Mui-selected': {
                                color: 'var(--secondary-color)',
                            },
                        }} />
                    <Tab label="MMT3" style={{
                        fontSize: 'var(--font-size-header)',
                        fontFamily: 'var(--font-family-base)',
                    }}
                        sx={{
                            color: 'inherit',
                            '&.Mui-selected': {
                                color: 'var(--secondary-color)',
                            },
                        }} />
                </Tabs>
            </Box>
            <Box style={{ padding: reports ? '24px' : '0 0 0 0' }}>
                {renderContent()}
            </Box>
        </>
    )
}

export default ReportsBase
